<template>
  <div id="energy-supply-view">
    <div class="vx-col w-full mb-base">
      <vx-card ref="infoCard" :title="cardTitle" title-color="black">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
            <vs-button type="border" class="mr-3" icon-pack="feather" icon="icon-save" @click="saveData">{{ $t('Save') }}</vs-button>
            <vs-button type="border" class="mr-3" color="danger" @click="returnToList">{{ $t('Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
          <ValidationObserver ref="observer">
          <vs-tabs v-model="selectedTab"  :key="tabsKey">
              <vs-tab value="0" :label="$t('Decarbonization.GridEfficiencyTemplate.Tab1Title')" icon-pack="feather" icon="icon-settings">                
                <div class="p-6">
                  <vs-row class="mb-3">
                    <vs-col vs-w="6" class="mr-5">
                      <vs-row class="mb-3">
                        <vs-col vs-w="6">
                          <ValidationProvider :name="$t('Decarbonization.GridEfficiencyTemplate.Name')" rules="required" v-slot="{ errors }">
                            <validated-input
                              :label="$t('Decarbonization.GridEfficiencyTemplate.Name')"
                              v-model="name"
                            ></validated-input>
                            <validation-message>{{ errors[0] }}</validation-message>
                          </ValidationProvider>
                        </vs-col>
                      </vs-row>
                    </vs-col>               
                  </vs-row>
                </div>                
              </vs-tab>
              <vs-tab :disabled="id == 0" value="1" :label="$t('Decarbonization.GridEfficiencyTemplate.Tab2Title')" icon-pack="feather" icon="icon-calendar" v-b-tooltip.hover :title="id === 0 ? $t('Decarbonization.GridEfficiencyTemplate.Tab2Unavailable') : ''">
                  <rates
                    ref="rates"
                    :rates="rates"
                    :gridEfficiencyTemplateId="id"
                    @onInserted="onInserted"
                    @onUpdated="onUpdated"
                    @onDeleted="onDeleted"
                  />
              </vs-tab>
            </vs-tabs>
          </ValidationObserver>
      </vx-card>
    </div>
  </div>
</template>

<script>

import Rates from './components/Rates.vue'
import module from "../../store/module.js";
import {
  ValidatedInput,
  ValidationMessage
} from "../../../../shared/components";

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Rates
  },
  data() {
    return {
      id: 0,
      name : '',      
      selectedTab: 0,
      rates: [],
      tabsKey: 0
    };
  },
  watch: {
  },
  computed: {
    cardTitle()  {
      if (this.id !== null && this.id > 0)
        return this.name;
      else
        return this.$t('Decarbonization.GridEfficiencyTemplate.AddNew');
    }
  },
  created() {
    if (!module.isRegistered) {
      this.$store.registerModule("decarbonization", module);
      module.isRegistered = true;
    }
    if (this.$route.params.editData !== undefined && this.$route.params.editData !== null) {
      this.id = this.$route.params.editData.id;
      this.name = this.$route.params.editData.name;
      this.rates = this.$route.params.editData.rates;
    }
    else {
      this.initValues();
    }
  },
  mounted() {
  },

  methods: {
    initValues() {
      if (this.data) return;
      this.id = 0;
      this.name = "";
      this.selectedTab = 0;
      this.rates = [];
    },
    saveData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.id,
            name: this.name,
            rates: this.rates
          };
          this.$vs.loading();

          if (this.id !== null && this.id > 0) {
            this.$store.dispatch("decarbonization/updateGridEfficiencyTemplate", obj).then((results) => {
              this.$notifySaveSuccess();
              this.rates = results.data.rates;
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("decarbonization/addGridEfficiencyTemplate", obj).then((results) => {
              this.$notifySuccess(this.$t('InsertSuccess'));
              this.id = results.data.model.id;
              this.rates = results.data.model.rates;
            }).finally(() => {
              this.selectedTab = 2;
              this.forceRefreshTabs();
              this.$vs.loading.close();
            });
          }
        }
        else {
          this.$notifySaveError();
        }
      });
    },
    returnToList() {
      this.$router.push({ name: 'BSG-decarbonization-admin-gridEfficiencyTemplates'});
    },
    onInserted(item) {
      this.rates.push(item);
    },
    onUpdated(item) {
      this.rates = this.rates.map(obj => this.rates.find(o => o.id !== obj.id) || item);
    },
    onDeleted(id) {
      this.rates = this.rates.filter(u => u.id !== id);
    },
    forceRefreshTabs() {
      this.tabsKey++;
    }
  }
};
</script>
